export default {
  title: 'Guardar datos de contacto y pago',
  form: {
    remember_me: {
      label: 'Crea una cuenta para finalizar tus próximos pedidos más rápido.',
    },
  },
};
